// Google Analytics custom event tracking
export const trackEvent = (eventName, params = {}) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
};

// Pre-defined events
export const analytics = {
  vote: (voteType) => trackEvent('vote', { vote_type: voteType }),
  vent: (isSuggestion) => trackEvent('vent_posted', { is_suggestion: isSuggestion }),
  reaction: (type, action) => trackEvent('reaction', { reaction_type: type, action }),
  share: (platform) => trackEvent('share', { platform }),
  splashComplete: () => trackEvent('splash_complete'),
  filterChange: (filter) => trackEvent('feed_filter', { filter }),
  // Vent to a Dog — per-dog attribution via ga_tag + species (dog/cat) for rollups
  dogImpression: (gaTag, species) => trackEvent('dog_impression', { dog: gaTag, species }),
  dogVentStart: (gaTag, isFree, species) => trackEvent('dog_vent_start', { dog: gaTag, is_free: isFree, species }),
  dogVentComplete: (gaTag, species) => trackEvent('dog_vent_complete', { dog: gaTag, species }),
  dogHeart: (gaTag, species) => trackEvent('dog_vent_heart', { dog: gaTag, species }),
  dogShare: (gaTag, species) => trackEvent('dog_vent_share', { dog: gaTag, species }),
  dogWoof: (gaTag, species) => trackEvent('dog_vent_woof', { dog: gaTag, species }),
  emailCapture: (gaTag, species) => trackEvent('email_capture', { dog: gaTag, species }),
  wantMore: () => trackEvent('want_more', {}),
  adventureOpen: (slug) => trackEvent('adventure_open', { adventure: slug }),
};
